export const TIME_OPTIONS_MINUTES_STEP = 15;
export const MAX_HOURS = 24;
export const MAX_MINUTES = 60;
export const TIME_OPTION_HEIGHT = 40;
